import { GrayscaleFilter as PixiGrayscaleFilter } from 'pixi-filters';
import { Config } from '../../video-data/config';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';


export class GreyscaleFilter extends Filter {
    override _classType = Config.GREYSCALE_FILTER;
    override pixiFilter: PixiGrayscaleFilter;

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new PixiGrayscaleFilter();
    }
}
